export { default } from "./FormatMoney.vue";
